"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const lucide_vue_next_1 = require("lucide-vue-next");
const TabularController_1 = __importDefault(require("@becrop/components/Farms/Abstract/Controllers/TabularController"));
const debounce_1 = require("@common/tsutils/debounce");
const MetricRankTag_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/MetricRankTag.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
let FieldsTable = class FieldsTable extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.CONTROLLER = TabularController_1.default.getInstance();
        this.loadingField = false;
        this.subtableHelperWidth = 242;
        this.scrollOffset = 0;
        this.maxWidthSubTable = `calc(100vw - ${this.subtableHelperWidth}px)`;
        this.tableWidth = 0;
        this.subtableWidth = document.documentElement.clientWidth - this.subtableHelperWidth;
        this.expandedRows = [];
        this.filters = {
            global: { value: null, matchMode: bmk_ui_framework_1.FilterMatchMode.CONTAINS },
            'farm.name': { value: null, matchMode: bmk_ui_framework_1.FilterMatchMode.CONTAINS },
            name: { value: null, matchMode: bmk_ui_framework_1.FilterMatchMode.CONTAINS },
            'crop.name': { value: null, matchMode: bmk_ui_framework_1.FilterMatchMode.CONTAINS },
            'client.name': { value: null, matchMode: bmk_ui_framework_1.FilterMatchMode.CONTAINS },
        };
        this.filteringOptions = [
            { label: 'Farm', value: 'farm.name' },
            { label: 'Crop', value: 'crop.name' },
            { label: 'Client', value: 'client.name' },
            { label: 'Field', value: 'name' },
        ];
        this.filterCriteria = { label: 'Farm', value: 'farm.name' };
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get fields() {
        return this.CONTROLLER.tabularSet.fields;
    }
    get farms() {
        return this.CONTROLLER.farms;
    }
    get categoriesColumns() {
        return this.CONTROLLER.categoriesColumns;
    }
    get metricsColumns() {
        return this.CONTROLLER.metricsColumns;
    }
    get acreageMode() {
        return this.CONTROLLER.acreageMode;
    }
    get loading() {
        return this.CONTROLLER.loading;
    }
    toggleAcreageMode() {
        this.CONTROLLER.toggleAcreageMode();
    }
    filterCallbackBMK(field, model) {
        if (this.filters[field] !== model) {
            this.filters[field] = model;
        }
    }
    setFilter(criteria, value) {
        this.filterCriteria = this.filteringOptions.find((o) => o.label === criteria);
        this.filters[this.filterCriteria.value].value = value;
    }
    changeFilterCriteria(criteria) {
        // console.log(criteria)
    }
    rowClass(data) {
        return (!data.hasMetrics) ? 'field--no_metrics' : '';
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 35, 35);
    }
    handleDownloadFieldPDF(id) {
        this.CONTROLLER.downloadFieldPDF(id);
    }
    handleMapAction(id) {
        // console.log('Mapa del field ' + id)
    }
    async fetchMetricsByField(field) {
        this.loadingField = true;
        const metrics = await this.CONTROLLER.fetchFieldMetrics(field.id, field.farm.id);
        this.loadingField = false;
        field.metrics = metrics;
        return metrics;
    }
    findMetric(field, code) {
        return field.findMetric(code);
    }
    polishClass(field, code) {
        const metric = this.findMetric(field, code);
        if (metric) {
            if (metric.rankLabelShort !== 'm') {
                if (metric.scale === 'std')
                    return `bmfw-color-bmk_rank_${metric.rankLabelShort}`;
                return `bmfw-color-bmk_rank_alt_${metric.rankLabelShort}`;
            }
            else {
                return 'no-shadow';
            }
        }
        return '---';
    }
    findMetricIxInColumn(code) {
        return this.CONTROLLER.findMetricIxInColumn(code);
    }
    isFirstMetricInColumn(code) {
        return this.CONTROLLER.isFirstMetricInColumn(code);
    }
    isAggregatedMetric(code) {
        return (code.toLowerCase().startsWith('num')) ? true : false;
    }
    expandRow(id) {
        this.expandedRows.push(id.toString());
        this.table.expandRow(id.toString());
    }
    collapseRow(id) {
        this.expandedRows = this.expandedRows.filter((r) => r !== id.toString());
        this.table.collapseRow(id.toString());
    }
    triggerAggregated(id, code) {
        if (this.table) {
            this.tableWidth = this.table.$el.querySelector('.p-datatable-scrollable-table').clientWidth;
            this.expandRow(id);
        }
        else {
            console.error("La referencia al hijo es nula.");
        }
    }
    handleScroll(event) {
        if (this.expandedRows.length > 0) {
            if (event.target.scrollLeft < (this.tableWidth - this.subtableWidth)) {
                this.scrollOffset = event.target.scrollLeft;
            }
        }
        else {
            this.scrollOffset = event.target.scrollLeft;
        }
    }
    async mounted() {
        this.CONTROLLER.fetchFarms();
        this.table = this.$refs.advancedTable;
        const scrollableBody = this.table.$el.querySelector('.p-datatable-table-container');
        scrollableBody.addEventListener('scroll', this.handleScroll);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], FieldsTable.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'm' })
], FieldsTable.prototype, "size", void 0);
__decorate([
    (0, debounce_1.Debounce)(100)
], FieldsTable.prototype, "handleScroll", null);
FieldsTable = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            AdvancedTable: bmk_ui_framework_1.AdvancedTable,
            Column: bmk_ui_framework_1.Column,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            MapPin: lucide_vue_next_1.MapPin,
            Button: bmk_ui_framework_1.Button,
            ColumnGroup: bmk_ui_framework_1.ColumnGroup,
            Row: bmk_ui_framework_1.Row,
            InputFieldV2: bmk_ui_framework_1.InputFieldV2,
            Search: lucide_vue_next_1.Search,
            SelectV2: bmk_ui_framework_1.SelectV2,
            SelectField: bmk_ui_framework_1.SelectField,
            Toggle: bmk_ui_framework_1.Toggle,
            ChevronDown: lucide_vue_next_1.ChevronDown,
            MetricRankTag: MetricRankTag_vue_1.default,
        },
    })
], FieldsTable);
exports.default = FieldsTable;
